import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicDailyRoomSystemSessionDurationAggregate } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getDailyAggregatedRoomSystemSession = async ({
  from,
  to,
  organisationId,
  roomSystemId,
}: {
  from: string;
  to: string;
  organisationId?: string;
  roomSystemId?: string;
}): Promise<PublicDailyRoomSystemSessionDurationAggregate[]> => {
  const response = await axiosClient.get(
    `/analytics/average-room-system-session-duration`,
    {
      params: {
        from,
        to,
        organisationId,
        roomSystemId,
      },
    },
  );
  return response.data;
};

export function getDailyAggregatedRoomSystemSessionQueryKey({
  from,
  to,
  organisationId,
  roomSystemId,
}: {
  from: string;
  to: string;
  organisationId?: string;
  roomSystemId?: string;
}) {
  return [
    "daily-aggregated-room-system-session",
    from,
    to,
    organisationId,
    roomSystemId,
  ];
}

export function useGetDailyAggregatedRoomSystemSession(
  {
    from,
    to,
    organisationId,
    roomSystemId,
  }: {
    from: string;
    to: string;
    organisationId?: string;
    roomSystemId?: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<PublicDailyRoomSystemSessionDurationAggregate[], HttpError>
  >,
) {
  return useQuery({
    queryKey: getDailyAggregatedRoomSystemSessionQueryKey({
      from,
      to,
      organisationId,
      roomSystemId,
    }),
    queryFn: () =>
      getDailyAggregatedRoomSystemSession({
        from,
        to,
        organisationId,
        roomSystemId,
      }),
    ...queryOptions,
  });
}
